import React, { useState, useEffect, useContext } from "react";
import axios from 'axios';
import { ThemeContext } from '../themeContext';
import logo from "../assets/logo.png";
import check from "../assets/check.png";

const buttonStatus = ["Verify", "Verifying Merchant...", "Register Merchant", "Registering...", "Add another merchant"]

const cloverAPI = "https://api.clover.com/v3";
const shuboxAPI = "https://backend.getshubox.com/api/v1";

const capitalizeWords = (string) => {
    if (!string) return ''; // Check if the string is empty or undefined
    // Convert the first letter to uppercase and the rest to lowercase
    return string
        .split(" ") // Split the string into an array of words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter and make the rest lowercase
        .join(" "); // Join the words back into a single string
};

const categories = [
    "Accounting/Bookkeeping",
    "Advertising/Promotional",
    "Auto Fuel/Oil/Repair",
    "Bank Fees",
    "Contractor Services",
    "Credit Card Fees",
    "Dues and Subscriptions",
    "Entertainment",
    "Equipment Rental",
    "Freight, Postage, and Shipping",
    "Insurance Business",
    "Insurance Health",
    "Insurance Vehicle",
    "Interest Expense",
    "Laundry",
    "Legal Fees",
    "Medical/Dental Expense",
    "Pharmacy/Drug",
    "Rent",
    "Retail Clothing and Accessories",
    "Retail Food, Beverage, and Grocery",
    "Retail Gift, Novelty, and Souvenir",
    "Retail Building Materials",
    "Retail Office and Stationery",
    "Retail Other Supplies",
    "Restaurant Meals",
    "Security Service",
    "Storage Rental",
    "Telephone",
    "Transportation, Travel, and Lodging",
    "Utility Services",
    "Waste and Removal",
    "Miscellaneous"
];

export default function MainSection() {
    const [values, setValues] = useState({
        authenticationCode: "",
        merchantId: "",
        name: "",
        image: "",
        address: "",
        email: "",
        phone: ""
    });
    const [value, setValue] = useState('');
    const [city, setCity] = useState("");

    const [verified, setVerification] = useState(false);
    const [buttonTitle, setButtonTitle] = useState(buttonStatus[0])
    const [successfulRegistration, setSuccessfulRegistration] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageValidation, setErrorMessageValidation] = useState([]);

    const { verifiedGlobal, updateVerifiedGlobal, updateSuccessRegistrationGlobal } = useContext(ThemeContext);

    const findInvalidCharacters = (str) => {
        // Regular expression to match anything that is not a letter, number, or hyphen
        const regex = /[^a-zA-Z0-9-]/g;

        // Use the match method to find all invalid characters
        const invalidCharacters = str.inputName.match(regex);

        const result = `Remove the invalid characters found in ${str.name}: ${[...new Set(invalidCharacters)]}`;

        // console.log(result, 'invalidCharacters');
        // If there are invalid characters, return them as a unique array; otherwise, return an empty array
        let status = invalidCharacters ? result : false;

        // console.log(status, 'status', errorMessage);

        return status;
    };

    const verification = [
        {
            id: 1,
            name: "authenticationCode",
            type: "text",
            placeholder: "Enter Your Clover Authentication Code",
            errorMessage:
                "Authentication code must be 36 characters",
            label: "Clover Authentication Code",
            pattern: "^.{36}$",
            required: true,
        },
        {
            id: 2,
            name: "merchantId",
            type: "text",
            placeholder: "Enter Your Clover Merchant ID",
            errorMessage: "Merchant ID must be 13 characters",
            label: "Merchant ID",
            pattern: "^.{13}$",
            required: true,
        },
    ];

    const merchantFields = [
        {
            id: 3,
            name: "name",
            type: "text",
            placeholder: "Name",
            errorMessage: "Name should not be less than 2 and greater than 25 characters",
            label: "Merchant Name",
            pattern: "^.{2,25}$",
            required: true,
        },
        {
            id: 4,
            name: "image",
            type: "text",
            placeholder: "Enter A HTTPS URL Image",
            errorMessage: "It should be a valid https URL image link",
            label: "Merchant Logo",
            required: true,
        },
        {
            id: 5,
            name: "category",
            list: "category",
            type: "select",
            placeholder: "Enter Your Business Category",
            errorMessage: "Category cannot be 2 or less, and more than 40 characters",
            label: "Category",
            pattern: "^.{2,40}$",
            required: true,
        },
        {
            id: 6,
            name: "address",
            type: "text",
            placeholder: "Enter Your Business Address",
            errorMessage: "It should be a valid business address!",
            label: "Merchant Address",
            required: true,
        },
        {
            id: 7,
            name: "email",
            type: "email",
            placeholder: "Enter Your Business Email",
            errorMessage: "It should be a valid email address!",
            label: "Email",
            required: true,
        },
        {
            id: 8,
            name: "phone",
            type: "number",
            placeholder: "Enter Your Business Phone",
            errorMessage: "It should be a valid phone number and cannot be less than 10 numbers ",
            label: "Merchant Phone",
            required: true,
        },
    ];


    const runCloverVerificationAndShuboxRegistration = (merchantAlreadyAdded, merchantId, authenticationCode, name, image, category, address, email, phone) => {
        if (merchantAlreadyAdded === false) {
            if (!verified) {
                setButtonTitle(buttonStatus[1])
                axios(`${cloverAPI}/merchants/${merchantId}?expand=address,name,logos,owner,email,phone,category`, {
                    method: 'GET',
                    headers: { 'AUTHORIZATION': `Bearer ${authenticationCode}` },
                })
                    .then((response) => {
                        // handle success
                        if (response.status === 200) {
                            console.log(response, 'response');
                            const { address: { address1, city, country, state, zip }, owner: { email }, name, logos } = response.data;
                            const cityFirstletterUppercase = capitalizeWords(city);
                            console.log(cityFirstletterUppercase, 'cityFirstletterUppercase')
                            setCity(cityFirstletterUppercase);
                            setValues({ ...values, name: capitalizeWords(name), image: logos?.elements[0]?.url || '', address: `${capitalizeWords(address1) + ", " + cityFirstletterUppercase + ", " + state + ", " + zip + ", " + country}`, email: email.toLowerCase() });
                            setVerification(true);
                            updateVerifiedGlobal(true);
                            setButtonTitle(buttonStatus[2])
                        } else {
                            setButtonTitle(buttonStatus[0]);
                        };
                    })
                    .catch((error) => {
                        // handle error
                        setVerification(false);
                        updateVerifiedGlobal(false);
                        setButtonTitle(buttonStatus[0]);

                        if (error?.response?.status === 401) {
                            return setErrorMessage("Authentication Code/Merchant ID doesn't match with Clover. Please check and correct the keys");
                        } else {
                            setErrorMessage("An error occurred while verifying, please reload and try again");
                        }
                    })
            } else {
                setButtonTitle(buttonStatus[3]);

                axios(`${shuboxAPI}/add-merchant`, {
                    method: 'POST',
                    data: {
                        name,
                        image,
                        category,
                        address,
                        email,
                        phone,
                        clover_merchant_id: merchantId,
                        clover_oauth: authenticationCode
                    }
                })
                    .then((response) => {
                        console.log(response, 'response here')
                        // handle success
                        if (response.status === 201) {
                            setSuccessfulRegistration(true)
                            updateSuccessRegistrationGlobal(true);
                            setButtonTitle(buttonStatus[4]);
                        };
                    })
                    .catch((error) => {
                        console.log(error, 'error was here');

                        // handle error
                        setButtonTitle(buttonStatus[2])
                        setSuccessfulRegistration(false)
                        if (error?.response?.data?.error) {
                            return setErrorMessage(error.response.data.error);
                        } else {
                            setErrorMessage("An error occurred while registering this merchant, please reload and try again");
                        }
                    })
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (buttonTitle === buttonStatus[4]) {
            return resetMerchant();
        };


        const { merchantId, authenticationCode, name, image, category, address, email, phone } = values;
        setErrorMessage("");
        setErrorMessageValidation([])

        if (buttonTitle === buttonStatus[0]) {
            let error = [];
            [{ name: "Clover Authentication Code", inputName: authenticationCode }, { name: "Clover Merchant ID", inputName: merchantId }].forEach(element => {
                const validity = findInvalidCharacters(element);
                if (validity !== false) {
                    error.push(validity);
                };
            });

            if (error.length > 0) {
                setErrorMessage(error);
                setErrorMessageValidation(error);
                return;
            }

            // 780bdeb3-a32f-249d-8955-ee56833cad*&
            // RDDXBY1EK31*&
        };

        //before verifying check, if the merchant details has already been entered into our system
        let merchantAlreadyAdded;

        axios(`${shuboxAPI}/verify-merchant/${merchantId}/${authenticationCode}`, {
            method: 'GET',
        }).then((response) => {
            if (response.status === 200) {
                merchantAlreadyAdded = false;
                runCloverVerificationAndShuboxRegistration(merchantAlreadyAdded, merchantId, authenticationCode, name, image, category, address, email, phone)
            }
        }).catch((error) => {
            merchantAlreadyAdded = true;
            if (error.response.status === 409) {
                setErrorMessage("Merchant with clover ID and Clover Oauth has already been registered on Shubox")
            } else {
                setErrorMessage("Verification failed, sorry please reload and try again.")
            }
        })
    };

    const onChange = (e) => {
        setValue(e.target.value);
        setValues({ ...values, [e.target.name]: e.target.value.trim() });
    };


    const resetMerchant = () => {
        setSuccessfulRegistration(false); setVerification(false); updateVerifiedGlobal(false); setValues({
            authenticationCode: "",
            merchantId: "",
            name: "",
            image: "",
            address: "",
            email: "",
            phone: ""
        }); setButtonTitle("Verify"); setErrorMessage("");
    };

    return (
        <div className="mainSection">
            {!successfulRegistration && <h3 className="mainSectionHeader">Register Merchant Account</h3>}
            <form onSubmit={handleSubmit}>
                {values.image !== "" ? (<div className="logo">
                    <img style={{ height: 120, borderRadius: 100, marginRight: 10, width: 120, maxWidth: "100%", borderColor: "black", borderWidth: "2px", borderStyle: "solid" }} src={successfulRegistration ? check : values.image} alt={"shubox merchant logo"} />
                </div>
                ) : null}

                {successfulRegistration ? (
                    <>
                        <h3>{`${city}! ${values.name} was successfully registered`}</h3>
                    </>
                ) : (
                    <>
                        {
                            verified ? (
                                <>
                                    {
                                        merchantFields.map((input) => (
                                            <>


                                                {input.type === "select" ? (
                                                    <select id="select" name="browser" className="input" {...input} onChange={onChange}>
                                                        <option class="greenText" disabled="disabled" selected="selected">Select A Category</option>
                                                        {categories.map((category) => <option value={category}>{category}</option>)}
                                                    </select>
                                                ) : <input
                                                    key={input.id}
                                                    {...input}
                                                    value={values[input.name]}
                                                    onChange={onChange}
                                                />}
                                            </>
                                        ))
                                    }
                                </>
                            ) : (
                                <>
                                    {verification.map((input) => (
                                        <>
                                            <input
                                                key={input.id}
                                                {...input}
                                                value={values[input.name]}
                                                onChange={onChange}
                                            />
                                            {/* <label className={value && 'filled'} htmlFor={input.name}>
                                                {input.label}
                                            </label> */}
                                        </>
                                    ))}


                                </>
                            )}
                    </>
                )
                }



                {/* <input
                    type="text"
                    placeholder="Merchant Name"
                    onChange={handleChange}
                    name="firstName"

                />
                <input
                    type="text"
                    placeholder="Merchant Logo Url"
                    onChange={handleChange}
                    name="firstName"
                // value={formState.merchantLogoUrl}
                /> */}
                {/* <img 
                    src={logo}
                    alt="merchant-logo" 
                />
                  <input 
                    type="text" 
                    placeholder="Merchant Category"
                    onChange={handleChange}
                    name="firstName"
                    // value={formState.merchantCategory}
                />
                  <input 
                    type="text" 
                    placeholder="Merchant Address"
                    onChange={handleChange}
                    name="firstName"
                    // value={formState.merchantAddress}
                />
                  <input 
                    type="text" 
                    placeholder="Merchant Email"
                    onChange={handleChange}
                    name="firstName"
                    // value={formState.merchantEmail}
                />
                <input 
                    type="text" 
                    placeholder="Merchant phone"
                    onChange={handleChange}
                    name="firstName"
                    // value={formState.merchantPhone}
                /> */}

                {errorMessageValidation.length > 0 ? (
                    <ul>
                        {errorMessageValidation.map((message) => (
                            <li style={{ color: "red" }}>{message}</li>
                        ))}
                    </ul>
                ) : <p style={{ color: "red" }}>{errorMessage}</p>}

                <button className="register-merchant">{buttonTitle}</button>
                {verified === true && successfulRegistration !== true ? <button className="cancel-register" style={{}} onClick={resetMerchant}>Cancel</button> : null}

            </form >
        </div>
    )
}